import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { City } from '../../types';

export interface AllCitiesListRequestParams {
  CountryCode: string;
  StateCode: string;
}

export const getAllCitiesListAPI = (params: AllCitiesListRequestParams) => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetCities`,
    method: 'get',
    params,
  });
};

export type AllCitiesResponse = City[];

export const fetchAllCitiesList = async (params: AllCitiesListRequestParams): Promise<AllCitiesResponse> => {
  const response: AxiosResponse<AllCitiesResponse> = await getAllCitiesListAPI(params);
  return response.data;
};
